const sliderDefault = {
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  fade: true, 
  dots: false,
  arrows: true, 
  speed: 2000, 
  autoplaySpeed: 7000, 
  pauseOnHover: false,
};

const sliderContent = {
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  dots: false,
  arrows: false,
  adaptiveHeight: true,
  infinite: true,
  asNavFor: '.js-slider-carousel-nav'
};

const sliderNav = {
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  dots: false,
  arrows: true,
  focusOnSelect: true,
  asNavFor: '.js-slider-content'
};

const carouselSlider = {
  slidesToScroll: 1,
  slidesToShow: 1,
  dots: false,
  arrows: false,
  infinite: true,
  mobileFirst: true,
  centerMode: true,
  centerPadding: '7%',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 3,
        centerMode: false,
        slidesToScroll: 2,
        arrows: true,
      }
    }
  ]
}


export const slickInit = () => {
  $('.js-slider').slick(sliderDefault);
  $('.js-slider-content').slick(sliderContent);
  $('.js-slider-carousel-nav').slick(sliderNav);
  $('.js-slider-carousel').slick(carouselSlider)
};

export default slickInit;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/house-to-home-equity-corp-chisel/src/scripts/modules/slickSlider.js